import React from 'react'

function CateogaryLI({ cateogary }) {
    return (
        <li><a href={`/cateogary/${cateogary}`}>{cateogary.charAt(0).toUpperCase() + cateogary.slice(1)} </a></li>
    )
}

export default CateogaryLI
